import { useEffect, useState } from "react";
import { appPaths } from "../routes.config";

export function AdminLink({ userId }: { userId: string }) {
  const [authorizedId, setAuthorizedId] = useState<string | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    void fetch("/api/admin/access", { signal: controller.signal, cache: "no-store" }).then((response) => {
      if (!controller.signal.aborted) setAuthorizedId(response.ok ? userId : null);
    }).catch(() => { if (!controller.signal.aborted) setAuthorizedId(null); });
    return () => controller.abort();
  }, [userId]);
  return authorizedId === userId ? <a className="secondary-button" href={appPaths.admin}>Admin dashboard</a> : null;
}
